import { scheduleShorthandOnEnterSaga } from './ScheduleShorthand.onenter.saga';

export default (store, client) => ({
  path: '/s(chedule)/:scheduleId(\\d+)',
  status: 301,

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(scheduleShorthandOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb),
});
